import {Campaign} from '../../campaign/campaign';

import * as moment from 'moment';

export function toStrAdaccountID(adaccountID: string | number, prefix: string = 'act_'): string {
  function toStr(s: any): string {
    return (typeof s === 'string') ? s : s.toString();
  }

  const sID: string = toStr(adaccountID).toLowerCase();
  return sID.substring(0, 4) === prefix ? sID : `${prefix}${sID}`;
}


export function isSameObject(obj1: any, obj2: any): any {
  return JSON.stringify(obj1) === JSON.stringify(obj2);
}

export function isDifferentObject(obj1: any, obj2: any): any {
  return JSON.stringify(obj1) !== JSON.stringify(obj2);
}


export function parseQueryString(url: string): any {
  const queryString = require('query-string');
  return typeof url !== 'undefined' ? queryString.parse(url.split('?', 2)[1]) : null;
}

export function strToArray(input: string | Array<string>, delimeter: string = ','): Array<string> {
  if (Array.isArray(input)) {
    return input;
  } else {
    return input.split(delimeter);
  }
}

export function isNotEmptyDict(obj): boolean {
  return obj && Object.keys(obj).length > 0;
}

export function isEmptyDict(obj): boolean {
  return !isNotEmptyDict(obj);
}

export function getUserLocale(defaultLocale = 'ko_KR'): string {
  const locale = localStorage.getItem('user_locale');
  return locale ? locale : defaultLocale;
}

export function sortByKey(data: Array<any>, key: string, is_ascending = true): Array<any> {
  return data.sort((a, b) => {
    if (a[key] > b[key]) {
      return is_ascending ? 1 : -1;
    } else if (a[key] < b[key]) {
      return is_ascending ? -1 : 1;
    } else {
      return 0;
    }
  });
}

export function todayStr(format = 'YYMMDD', default_locale = 'ko_KR'): string {
  const language = window.navigator.language || default_locale;
  moment.locale(language);
  return moment().format(format);
}

export function now(format = 'YYYYMMDD HHmmss', default_locale = 'ko_KR'): string {
  const language = window.navigator.language || default_locale;
  moment.locale(language);
  return moment().format(format);
}

export function getRandomInt(max) {
  return Math.floor(Math.random() * Math.floor(max));
}

export function isInterger(n: any): boolean {
  try {
    return !isNaN(parseInt(n, 10)) && isFinite(n);
  } catch (e) {
    return false;
  }
}


export function isAppAd(campaign: Campaign) {
  return campaign && campaign.objective === 'APP_INSTALLS';
}

export function isVideoAd(campaign: Campaign) {
  return campaign && campaign.objective === 'VIDEO_VIEWS';
}

export function isPageAd(campaign: Campaign) {
  return campaign && campaign.objective === 'PAGE_LIKES';
}

export function isPostAd(campaign: Campaign) {
  return campaign && campaign.objective === 'POST_ENGAGEMENT';
}

export function isConversionAd(campaign: Campaign) {
  return campaign && campaign.objective === 'CONVERSIONS';
}




export function filterByKeys(obj: object, keys: Array<string>): any {
  const d = {};
  Object.keys(obj)
    .filter(_key => keys.includes(_key))
    .forEach(_key => d[_key] = obj[_key]);
  return d;
}

const COUNTRIES = {
  KR: 'South Korea',
  JP: 'Japan',
  IT: 'Italy'
};

export function countryKeysToDict(keys: Array<string>): Array<any> {
  return __keysToDict(keys, COUNTRIES, {type : 'country'});
}

const LOCALES = {
  12: 'Korean',
};
export function localeKeysToDict(keys: Array<string>): Array<any> {
  return __keysToDict(keys, LOCALES);
}

function __keysToDict(keys: Array<string>, dict: object, default_attrs?: object): Array<any> {
  return keys
    ? keys.map(_key => {
      const d = {
        key: _key,
        name: dict[_key] ? dict[_key] : _key,
      };
      return default_attrs ? Object.assign({}, d, default_attrs) : d;
    })
    : [];
}

export function arrayToObject(arrs: Array<any>, defaultValue = null) {
  const obj = {};
  arrs.forEach(_arr => obj[_arr] = defaultValue);
  return obj;
}

export function getDeepValue(obj: object, keys: Array<string>): any {
  let value = Object.assign({}, obj);
  keys.forEach(_key => {
    if (_key in value) {
      value = value[_key];
    } else {
      return value;
    }
  });
  return value;
}



// WEBPACK FOOTER //
// ./src/app/manager/shared/service/utils.ts